export var Settings = {
    /**
     * @description Force MSAA for rendering to image bitmap (WebGL2), 0 - disable, 1-16 - msaa quality
     */
    ALLOW_FORCE_MSAA: 8,
    /**
     * @description Image size start from it MSAA is runned for image (without temporary copy)
     */
    MSAA_MINIMAL_IMAGE_SIZE: 300,
    /**
     * @description Try approximate MSAA for unsupported platforms by rendering to N time biggest texture
     */
    ALLOW_APPROXIMATION: 0,
    /**
     * @description Generate texture cache when cacheAsBitmap is assigned
     */
    IMMEDIATE_CACHE_AS_BITMAP: false,
    /**
     * @description Currently cache-as-bitmap is unsafe feature, and produce a lot of bugs
     */
    USE_UNSAFE_CACHE_AS_BITMAP: false,
    /**
     * @description Currently cache-as-bitmap is unsafe feature, and produce a lot of bugs
     */
    USE_UNSAFE_SCALE_9_SLICE: false,
    /**
     * @description Use applyFilter for SceneImage2D
     */
    USE_UNSAFE_FILTER: false,
};
